var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60514 2C5.0831 2.00014 4.58247 2.20759 4.21333 2.57673C3.84419 2.94588 3.63674 3.4465 3.6366 3.96855V12.3309C3.6366 12.7735 3.81237 13.1979 4.12527 13.5109C4.43817 13.8239 4.86257 13.9999 5.30514 14H9.09114C9.8584 14.0004 10.6014 13.7313 11.1904 13.2395C11.7794 12.7478 12.1769 12.0648 12.3134 11.3098C12.45 10.5548 12.317 9.77579 11.9375 9.10891C11.5581 8.44202 10.9565 7.92964 10.2377 7.66127C10.7168 7.21254 11.0498 6.63011 11.1936 5.98965C11.3374 5.34918 11.2853 4.68028 11.044 4.06982C10.8027 3.45936 10.3835 2.93555 9.84069 2.56644C9.29789 2.19733 8.65664 1.99997 8.00023 2H5.60514ZM8.00023 7.45455C8.57889 7.45455 9.13384 7.22468 9.54301 6.81551C9.95218 6.40634 10.1821 5.85138 10.1821 5.27273C10.1821 4.69407 9.95218 4.13912 9.54301 3.72995C9.13384 3.32078 8.57889 3.09091 8.00023 3.09091H5.60514C5.12023 3.09091 4.72751 3.48364 4.72751 3.96855V7.45455H8.00023ZM4.72751 8.54545V12.3315C4.72751 12.6505 4.98605 12.9091 5.30514 12.9091H9.09114C9.6698 12.9091 10.2248 12.6792 10.6339 12.2701C11.0431 11.8609 11.273 11.3059 11.273 10.7273C11.273 10.1486 11.0431 9.59366 10.6339 9.18449C10.2248 8.77532 9.6698 8.54545 9.09114 8.54545H4.72751Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.752f7e5ceec4595d09c855dd87386205.svg";
export { ForwardRef as ReactComponent };